import React, { Component } from 'react';
import axios from 'axios'
import * as moment from 'moment';
import { serverIp, firebaseAuth, } from '../../../../config/constants.js'
import { Button, Icon } from 'semantic-ui-react'
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import { checkAdminEmail } from '../../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';


class DepositReminder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            type: ''
        }
    }

    componentDidMount() {
        // console.log("++++++++++:DepositReminder");
        // console.log("this.props.order.key:" + this.props.order.key);
        // console.log("this.props.user.email:" + this.props.user.email);
        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
           // console.log("elx1 +++++++++:removeListener");

            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }

        })
    }

    setAdminResult = (returnObject) => {
       // console.log("++++++ addx294 setAdminResult");
      //  console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));
        this.setState({
            algoliaUser: returnObject.algoliaUser,
            isAdmin: returnObject.isAdmin,
        })
    }

    sendUpdateToApi = (sentType) => {

        axios.post(serverIp + 'deposit/sendDepositReminderSms', {
            apiKey: 'getLastTransactions',
            fbOrderKey: this.props.mainOrder.key,
        })
            .then((response) => {
                console.log(response.data);
            })
            .catch((error) => {
                console.log(error);
            });

        var d = new Date();
        let now = moment().format('MMMM Do, h:mm:ss a');

        let orderUpdates = {
            depositReminderSent: true,
            depositReminderSentBy: this.props.user.email,
            lastUpdate: now,
            status: 'lost'
        }

        //upATE MAIN ORDER
        FbUtils.updateOrder(this.props.mainOrder.key, orderUpdates);
    }

    render() {

        const sendReminderButton = this.props.order.depositReminderSent
            ? <h3><Icon loading name='asterisk' /> REMINDER SENT </h3>
            : <Button type='Button' onClick={this.sendUpdateToApi} type='button' color='purple' fluid size='large'>SEND REMINDER</Button>


        const userEmail = this.state.user && this.state.user.email
            ? <h3>{this.state.user.email}</h3>
            : 'no email'


        const wholeUI = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.depositReminder
            ? <div>

                {sendReminderButton}

            </div>
            : ""

        return (
            <div>
                {wholeUI}
            </div>
        )
    }
}

export default DepositReminder;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/DespositReminder/DepositReminder.js